export const useQueryParams = (values: string[]) => {
    const queryParams = new URLSearchParams(location.search);

    return values.map((value) => queryParams.get(value));
};
